import { IListPesticide, IListPlantType } from '../../../../pages/products/Products.interface';
import { IRetailerArea } from '@models/retailer.model';
import { IAreaRoot } from '../../../../pages/adminsettings/area/area.interface';
import { IGenericValueDisplay } from '@shared/interface/generic';

export class InputSelectInterface implements IGenericValueDisplay {
  value: string;
  display: string;
  code?: string;
  labelExtra?: string;
  disabled?: boolean;
}

export class ISelectPlantType extends InputSelectInterface {
  setPlantTypeOptions(_selector: IListPlantType) {
    const { id, name } = _selector;
    this.value = id;
    this.display = name;
  }
}

export class ISelectPesticide extends InputSelectInterface {
  setPesticideOptions(_selector: IListPesticide) {
    this.value = _selector.name;
    this.display = _selector.name;
  }
}

export class ISelectRetailer extends InputSelectInterface {
  setOptions(_selector: IRetailerArea) {
    const { id, name, user } = _selector;
    let _label = name;
    _label += user ? ', ' + user : ', -';
    this.value = id;
    this.display = _label;
  }
}

export class ISelectArea extends InputSelectInterface {
  setSelector(_selector: IAreaRoot) {
    const { id, name, code } = _selector;
    this.value = id;
    this.display = name;
    this.code = code;
  }
}
